
import {Navbar,Footer} from '../components';
import {Link} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import * as Icon from 'react-bootstrap-icons';
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";


const Mis=()=>{
    const user = JSON.parse(localStorage.getItem('user'));

    if(localStorage.getItem('branchID')===null){
        window.location.replace('/');
    }

    const [misData,setMisData]=useState([]);
    const [fYear,setfYear]=useState('');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [passcode,setPasscode]=useState('');
    const [misID,setMisID]=useState('');
    const [dataFound,setDataFound]=useState(true);

    
    

    useEffect(() => {
        const getMisData = async () => {
            var date = new Date();
            var aMonth = date.getMonth()+1; // returns 0 - 11
            var aYear= date.getFullYear();
            if(aMonth<=6){aYear=aYear-1}
            setfYear(aYear);

            const response=await axios.get(configData.SERVER_URL+`/mis/${localStorage.getItem('branchID')}/${aYear}`);
            setMisData(response.data || []); 
        };

        Number(localStorage.getItem('branchID'))===10 ? setDataFound(false) : getMisData();

    }, []);

    const handleInput=(e)=>{
        setfYear(e.target.value);
    }


    const getMisDataByYear=async(e)=>{
        e.preventDefault();
        const response=await axios.get(configData.SERVER_URL+`/mis/${localStorage.getItem('branchID')}/${fYear}`)
        setMisData(response.data || []); 
    }

    const misApproved=(id)=>{
        setMisID(id);
        handleShow();
    }
    
    const handleSubmitPasscode=async(e)=>{
        e.preventDefault(); 
        if (window.confirm("want to Submit?")) {
            if(passcode===user.passcode){
            try {
                let res=await axios.post(configData.SERVER_URL+`/misDataApproved/${misID}`);
                if(res.status===200){
                alert(res.data.message);
                } 
                } catch (error) {
                console.error('System error:', error);
            } 
            }
            else {alert('Wrong Password');}
        }
        handleClose();
    }

    const printDiv = (printDiv) => {
        const printElement = document.getElementById(printDiv);

        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    ${printElement.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
  };


    return(
        <>
        {dataFound ? (
        <div className='container' >

        <Modal show={show} onHide={handleClose} style={{marginTop:50}}>
                <Modal.Header closeButton>
                  <Modal.Title>Re-Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmitPasscode}>
                    <Form.Group className="mb-3">
                        <Form.Label>Re-Confirm Passcode</Form.Label>
                        <Form.Control type="text" id="passcode" name="passcode" value={passcode} onChange={(e)=>{setPasscode(e.target.value)}} />
                    </Form.Group>
                    <Button variant="success" type="submit" id="btnPasscode">Submit</Button>
                    </Form>
                </Modal.Body>
        </Modal>
        <div className="justify-content-center">
          <div className="card " id='printDiv'>
                <div className="card-header">
                    <div><h3>MIS Info</h3></div>
                    <div className='col-lg-6 col-md-6 col-sm-12'> 
                        <div class="input-group">
                        <input type="search" class="form-control rounded" id='search' name='search' placeholder="Search" aria-label="Search" aria-describedby="search-addon" 
                        value={fYear} onChange={(e)=>{handleInput(e)}} />
                        <button  class="btn btn-outline-primary me-2"  onClick={getMisDataByYear}>search</button>
                        <Link to= {"/home/misReport/"+localStorage.getItem('branchID')+"/"+fYear} ><button className='btn btn-info me-2'><Icon.EyeFill size={24}/></button></Link>
                        <button className="btn btn-sm btn-warning" onClick={() => printDiv("printDiv")}> <Icon.PrinterFill size={24}/></button>
                        </div>                       
                    </div>
                </div>

                <div className="card-body table-responsive">
                    <div className="row ">
                    <table class="table table-success table-hover table-bordered" style={{fontSize:'small'}}> 
                        <thead>
                        <tr align="center">
                            <th>Month</th>
                            <th>Target Qty<hr></hr>Target Value</th>
                            <th>Cum. T.Qty<hr></hr>Cum. T.Value</th>
                            <th>Unit</th>
                            <th>Opening</th>
                            <th>Prod. Qty <hr></hr> Prod. Value</th>
                            <th>Cum. Pro.Qty<hr></hr>Cum. Pro.Value</th>
                            <th>Sales Qty <hr></hr> Sales Value</th>
                            <th>Cum. S.Qty<hr></hr>Cum. S.Value</th>
                            <th>Closing</th>
                            {/* <th>Sales Achivement<hr></hr>Cum. Sales Achi.</th> */}
                            <th>Operating Profit/Loss<hr></hr>Cum. Ope.P/L</th>
                            <th>Non-Ope. Profit/Loss<hr></hr>Cum. Non-Ope.P/L</th>
                            <th>Profit/ Loss<hr></hr>Cum. Profit/Loss</th>
                            
                            {/* <th>Pre.Year Pro.Qty<hr></hr>Pre.Year Pro.Value</th>
                            <th>Pre.Year Cum.Pro.Qty<hr></hr>Pre.Year Cum.Pro.Value</th>
                            <th>Pre.Year S.Qty<hr></hr>Pre.Year S.Value</th>
                            <th>Pre.Year Cum.S.Qty<hr></hr>Pre.Year Cum.S.Value</th> 
                            <th>Pre.Year P/L<hr></hr>Cum. P/L</th> */}
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            misData && misData.length>0 && misData.map((data)=> 
                        <tr align="right">
                            <td align="left">{data.monthName}</td>
                            <td>{Number(data.mtQty)}<hr></hr>{data.mtValue!== null ? Number(data.mtValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{data.cumMtQty!== null ? Number(data.cumMtQty).toFixed(2).toLocaleString('en-IN'):'0.00'}<hr></hr>{data.cumMtValue!== null ? Number(data.cumMtValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{data.units}</td>
                            <td>{Number(data.openingQty)}</td>
                            <td>{Number(data.proQty)}<hr></hr>{data.proValue!== null ? Number(data.proValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{Number(data.cumProQty)}<hr></hr>{data.cumProValue!== null ? Number(data.cumProValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{Number(data.salesQty)}<hr></hr>{data.salesValue!== null ? Number(data.salesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{Number(data.cumSalesQty)}<hr></hr>
                                {data.cumSalesValue!== null ? Number(data.cumSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}
                                {/* {data.cumSalesValue>data.cumPreSalesValue ? <Icon.ArrowUp color="green"/> : <Icon.ArrowDown color="red"/> } */}
                            </td>
                            <td>{Number(data.closingQty)}</td>
                            {/* <td>{data.salesQty!== null ? ((data.salesQty/data.mtQty)*100).toFixed(2):'0.00'} %<hr></hr>{data.cumSalesQty!== null ? ((data.cumSalesQty/(data.mtQty*data.fMonth))*100).toFixed(2).toLocaleString('en-IN'):'0.00'}</td> */}
                            <td>{data.operatingPL!== null ? Number(data.operatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}<hr></hr>{data.cumOperatingPL!== null ? Number(data.cumOperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{data.nonoperatingPL!== null ? Number(data.nonoperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}<hr></hr>{data.cumNonoperatingPL!== null ? Number(data.cumNonoperatingPL).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>                            
                            
                            <td>{data.profitLoss!== null ? Number(data.profitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}
                                <hr></hr>{data.cumProfitLoss!== null ? Number(data.cumProfitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}
                                {/* {data.cumProfitLoss>data.cumPreProfitLoss ? <Icon.ArrowUp color="green"/> : <Icon.ArrowDown color="red"/> } */}
                            </td>
                            
                            {/* <td>{data.preProQty}<hr></hr>{data.preProValue!== null ? (data.preProValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{data.cumPreProQty}<hr></hr>{data.cumPreProValue!== null ? (data.cumPreProValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{data.preSalesQty}<hr></hr>{data.preSalesValue!== null ? (data.preSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{data.cumPreSalesQty}<hr></hr>{data.cumPreSalesValue!== null ? (data.cumPreSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                            <td>{data.preProfitLoss!== null ? (data.preProfitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}<hr></hr>{data.cumPreProfitLoss!== null ? (data.cumPreProfitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}</td> */}
                            <td>
                                {data.approved==0 ?
                                <Link to= {"/home/misentry/"+data.id} ><button type='button' className='btn btn-info btn-sm'><Icon.Pencil /></button></Link>
                                :''}
                                {data.approved==0 ?
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => misApproved(data.id)}><Icon.CheckLg /></button>
                                :<span className="badge bg-success"><Icon.CheckCircleFill className="me-2" />Approved</span>
                                }
                            </td>
                        </tr>
                        )}
                        </tbody>
                    </table>                 
                    </div>
                </div>
          </div>
        </div>

        </div>
        ):(
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <h5>Not Authorized</h5>
        </div>
        )}
        </>
    )
}
export default Mis;